import TopicsCard from "./topicsCard";

const TopicsList = () => {
  return <TopicsCard />;
};

export default TopicsList;
